import {createAction} from '@reduxjs/toolkit';
import {PropertyID} from 'module/Properties/enum/PropID';
import {CompoundPropertyTO} from 'generated/JavaTO';

export const fetchPropertiesAction = createAction<PropertyID[]>('FETCH_PROPERTIES');

export const propertiesResponseAction = createAction<CompoundPropertyTO[]>('PROPERTIES_RESPONSE');
